/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var GridView = require('psa-marionette/views/GridView');

var AddressCell = require('common/backgrid/AddressCell');
var MomentCell = require('common/backgrid/MomentCell');
var ButtonLinkCell = require('common/backgrid/ButtonLinkCell');

module.exports = GridView.extend({
  className: 'dep-entity-location-view',

  onBeforeRender: function() {
    var entityTypeId = this.model.get('entityTypeId');
    var entityCategoryId = this.model.get('entityCategoryId');
    var isBank = entityCategoryId === '1';
    var isForeignFiduciary = entityTypeId === '24' || entityTypeId === '26';

    this.options.columns = [
      {
        name: 'officeType',
        label: 'Office Type',
        cell: 'string',
        headerCell: 'custom',
        width: 20,
        editable: false
      },
      {
        name: 'activity',
        label: 'Activity',
        cell: 'string',
        headerCell: 'custom',
        width: 20,
        editable: false,
        renderable: isBank
      },
      {
        name: 'address',
        label: 'Address',
        cell: AddressCell,
        headerCell: 'custom',
        width: 20,
        editable: false,
        sortable: false
      },
      {
        name: 'county',
        label: 'County',
        cell: 'string',
        headerCell: 'custom',
        width: 10,
        editable: false
      },
      {
        name: 'openedDate',
        label: 'Opened',
        cell: MomentCell.MomentCell,
        formatter: MomentCell.MomentDateFormatter.extend({
          emptyValue: '--'
        }),
        sortValue: MomentCell.MomentSortValue,
        headerCell: 'custom',
        width: 10,
        editable: false
      },
      {
        name: 'closedDate',
        label: 'Closed',
        cell: MomentCell.MomentCell,
        formatter: MomentCell.MomentDateFormatter.extend({
          emptyValue: '--'
        }),
        sortValue: MomentCell.MomentSortValue,
        headerCell: 'custom',
        width: 10,
        editable: false
      },
      {
        name: 'status',
        label: 'Status',
        cell: 'string',
        headerCell: 'custom',
        width: 20,
        editable: false
      },
      {
        name: '',
        label: '',
        cell: ButtonLinkCell.extend({
          name: 'Open',
          buttonClass: 'btn-primary btn-sm',
          href: function(model) {
            var entityId = model.get('entityId');
            var locationId = model.get('id');
            return '#dep/entity/' + entityId + '/location/' + locationId;
          }
        }),
        headerCell: 'custom',
        width: 20,
        editable: false,
        sortable: false
      }
    ];
    this.options.emptyText = isForeignFiduciary ? 'No Offices' : 'No Locations';
  }
});
